export function getErrorMessage(error: any): string {
  if (!error) return 'An unknown error occurred.';

  // Apollo GraphQL error
  if (
    error.graphQLErrors &&
    Array.isArray(error.graphQLErrors) &&
    error.graphQLErrors.length > 0
  ) {
    return error.graphQLErrors[0].message || 'A server error occurred.';
  }

  // Apollo network error
  if (error.networkError) {
    if (typeof error.networkError === 'string') return error.networkError;
    if (
      error.networkError.result &&
      error.networkError.result.errors &&
      error.networkError.result.errors.length > 0
    ) {
      return (
        error.networkError.result.errors[0].message ||
        'A network error occurred.'
      );
    }
    if (error.networkError.message) return error.networkError.message;
  }

  // REST API error with response data (GraphQL error array)
  if (error.response && error.response.data) {
    if (typeof error.response.data === 'string') return error.response.data;
    if (error.response.data.message) return error.response.data.message;
    if (
      Array.isArray(error.response.data.errors) &&
      error.response.data.errors.length > 0
    ) {
      // Prefer message from first error in array
      if (error.response.data.errors[0].message) {
        return error.response.data.errors[0].message;
      }
      // Fallback: return stringified first error if no message
      return JSON.stringify(error.response.data.errors[0]);
    }
  }

  // Raw GraphQL error (not Apollo)
  if (error.errors && Array.isArray(error.errors) && error.errors.length > 0) {
    return error.errors[0].message || 'A server error occurred.';
  }
  // Direct message
  if (error.message) return error.message;

  // Fallback
  return 'An error occurred. Please try again.';
}
